import React, { useState, useRef } from 'react';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import config from '@/config';
import { useDispatch } from 'react-redux';
import { initUser } from '@reduxSlices/user/userSlices';
import './styles.scss';
const { API_URL } = config;

const Login = () => {
  const [login, setLogin] = useState('');
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState('');
  const toast = useRef(null);

  const dispatch = useDispatch();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await fetch(`${API_URL}/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          login,
          password,
        }),
      });
      const { data, error } = await response.json();

      if (!response.ok || error) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      setLoading(false);
      dispatch(initUser(data));
      localStorage.setItem('authToken', data?.token);
    } catch (error) {
      setLoading(false);
      toast.current.show({
        severity: 'error',
        summary: 'Помилка авторизації',
        detail: `Не вірний логін або пароль!`,
        life: 5000,
      });
      console.error('Error during login:', error);
    }
  };

  const setValue = (eventState) => (event) => {
    eventState(event.target.value);
  };

  return (
    <div className='login-page'>
      <div className='flex align-items-center justify-content-center'>
        <div className='surface-card p-4 shadow-2 border-round w-full lg:w-6'>
          <div className='text-center mb-5'>
            <img src='/images/logo.svg' alt='hyper' height={50} className='mb-3' />
            <p className='text-900 text-3xl font-medium mb-3'>Форма входу</p>
          </div>

          <form onSubmit={handleLogin}>
            <label htmlFor='email' className='block text-900 font-medium mb-2'>
              Логін
            </label>
            <InputText id='email' type='text' className='w-full mb-3' onChange={setValue(setLogin)} />
            <label htmlFor='password' className='block text-900 font-medium mb-2'>
              Пароль
            </label>
            <InputText id='password' type='password' className='w-full mb-3' onChange={setValue(setPassword)} />
            <div className='login-page__button'>
              <Button label='Увійти' icon='pi pi-user' loading={loading} className='w-full' type='submit' />
            </div>
          </form>
        </div>
      </div>
      <Toast ref={toast} />
    </div>
  );
};

export default Login;
